import React, { ReactNode } from "react";

import { bem } from "@react-md/utils";
import cn from "classnames";
import invariant from "tiny-invariant";

const block = bem("mmc-loading-spinner");

interface LoadingSpinnerProps {
  ai?: boolean; // AI-palette tint, marking a "generating" wait rather than a plain load
  children?: ReactNode;
  className?: string;
  global?: boolean;
  inline?: boolean;
  micro?: boolean;
  mini?: boolean;
}

const LoadingSpinner = ({
  ai,
  children,
  className,
  global,
  inline,
  micro,
  mini,
}: LoadingSpinnerProps) => {
  invariant(
    !inline || !global,
    "Can't use both inline and global props, they're mutually exclusive"
  );

  return (
    <div className={cn(block({ ai, global, inline }), className)}>
      <div className={block("spinner", { micro, mini })} />
      {children && <div className={block("message")}>{children}</div>}
    </div>
  );
};

export default LoadingSpinner;
